"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _ActionNamespaces = require("../actions/ActionNamespaces");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _TicketStagePropertiesAPI = require("./api/TicketStagePropertiesAPI");

var _LazyValueStore = require("crm_data/store/LazyValueStore");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _default = (0, _LazyValueStore.defineLazyValueStore)({
  namespace: _ActionNamespaces.TICKET_STAGE_PROPERTIES,
  fetch: _TicketStagePropertiesAPI.fetch
}).defineName('TicketStagePropertiesStore').defineResponseTo(_ActionTypes.TICKET_STAGE_PROPERTIES_UPDATE_SUCCEEDED, function (state, _ref) {
  var stageId = _ref.stageId,
      properties = _ref.properties;
  return state.setIn(['value', stageId], (0, _immutable.fromJS)(properties));
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;